import { cn } from "@/lib/utils";
import { Skeleton } from "@/components/ui/skeleton";
import type { ReactNode } from "react";

interface TileGridProps {
  children: ReactNode;
  className?: string;
}

export function TileGrid({ children, className }: TileGridProps) {
  return (
    <div className={cn("grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4", className)}>
      {children}
    </div>
  );
}

interface TileGridSkeletonProps {
  count?: number;
  className?: string;
}

export function TileGridSkeleton({ count = 8, className }: TileGridSkeletonProps) {
  return (
    <TileGrid className={className}>
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} className="h-36 rounded-xl" />
      ))}
    </TileGrid>
  );
}
